export const DEFAULT_ACTOR_PLACEHOLDER_HEIGHT = 194;

export const ACTOR_CARD_MIN_HEIGHT = 380;

export const ACTOR_CARD_SX = {
  flexGrow: 1,
  display: 'flex',
  minHeight: ACTOR_CARD_MIN_HEIGHT,
} as const;

export const ACTOR_CARD_SIZE = {
  lg: 3,
  md: 6,
  xs: 12,
} as const;
